module.exports = __webpack_public_path__ + "static/media/Pwa_Config.8d0e8db3.svg";